module.exports = __webpack_public_path__ + "static/media/arrow-right-white.3e1cd112.svg";